import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
export class FormlyWrapperValidationMessages extends FieldWrapper {
   fieldComponent: ViewContainerRef;
/**
 * @return {?}
 */
get validationId() {
    return this.field.id + '-message';
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'formly-wrapper-validation-messages',
  template: `
    <ng-template #fieldComponent></ng-template>
    <div>
      <small class="invalid-feedback" [style.display]="'block'" *ngIf="showError" role="alert" [id]="validationId">
        <formly-validation-message [fieldForm]="formControl" [field]="field"></formly-validation-message>
      </small>
    </div>
  `,
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'fieldComponent': [{ type: ViewChild, args: ['fieldComponent', {read: ViewContainerRef}, ] },],
};
}

function FormlyWrapperValidationMessages_tsickle_Closure_declarations() {
/** @type {?} */
FormlyWrapperValidationMessages.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FormlyWrapperValidationMessages.ctorParameters;
/** @type {?} */
FormlyWrapperValidationMessages.propDecorators;
/** @type {?} */
FormlyWrapperValidationMessages.prototype.fieldComponent;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
